import angular from "angular";

export default ($timeout) => {
  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    link: ($scope, $element, $attr, $ctrl) => {
      const setValue = (elm, value, scope, ngModelCtrl) => {
        elm.val(value);
        ngModelCtrl.$setViewValue(value);

        $timeout(() => {
          elm.val(value);
          scope.$apply();
        });
      }

      const removeSpaces = e => {
        const elm = angular.element(e.currentTarget || e.srcElement);
        const value = elm.val();

        if (!value || value === ' ') {
          setValue(elm, '', $scope, $ctrl);
          return;
        }

        const cleanedValue = value.replace(/\s(?=\s)/g, ''); /* Delete double spaces */

        setValue(elm, cleanedValue, $scope, $ctrl);

        e.preventDefault();
      }

      $element.on('input', removeSpaces);
      $element.on('paste', removeSpaces);
    }
  };
}
